import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getSideFindList = (params) => {
  return httpService({
    url: contextPath + '/new-site/info',
    method: 'get',
    params
  })
}

export const getLabelList = (params) => {
  return httpService({
    url: contextPath + '/new-site-tag/list',
    method: 'get',
    params
  })
}

export const filterSpiderFindById = (params) => {
  return httpService({
    url: contextPath + '/new-site/item',
    method: 'put',
    params
  })
}
